import React, { useEffect, useState }         from 'react';
import { Group, Loader, Paper, Stack, Title } from '@mantine/core';
import { IconMap2 }                           from '@tabler/icons';
import { ClientOnly }                         from '@lib/ClientOnly';
import { getAddressText }                     from '@utils/dxb-utils';
import { CSection }                           from '@core/components/common/CSection';
import { MBMap }                              from '@core/components/common/Maps/MapBox/MBMap';
import { usePropertyState }                   from "@core/providers/PropertyStateProvider";

import useIsMounted                           from '@hooks/use-is-mounted';
import { useGetServiceKeysQuery }             from '../../../../../generated/graphql';
import useStyles                              from './MapSection.styles';


/*interface Props {
    location: Location;
}*/

export const MapSection: React.FC = () => {

    const { propertyDetailsData } = usePropertyState();

    // const { isDark } = useDxbTheme()
    const { data } = useGetServiceKeysQuery({
        fetchPolicy: 'cache-and-network'
    })

    const [mapBoxApiKey, setMapBoxApiKey] = useState<string>(null);

    const isMounted = useIsMounted();

    const { classes } = useStyles();

    useEffect(() => {

        if (data?.getServiceKeys) {

            const key = data?.getServiceKeys?.filter((_key) => _key.name === 'MAPBOX_ACCESS_TOKEN' && _key.value)[0].value

            setMapBoxApiKey(key);

            // console.log(key, 'key')
            // console.log(mapBoxApiKey, 'mapBoxApiKey')
            // console.log(location.latitude, location.longitude, location.street)

        }

    }, [data]);

    return isMounted && (
        <CSection
            heading="Where you'll be staying"
            content={
                <Stack>
                    <Group mt={-44} mb={30} className={classes.titleLocation}>
                        <IconMap2 className={classes.locationIcon} stroke={1}/>
                        <Title lineClamp={1} className={classes.h2} order={2}>{getAddressText(propertyDetailsData.location)}</Title>
                    </Group>

                    <ClientOnly>

                        {mapBoxApiKey && mapBoxApiKey
                            ? <MBMap
                                _key={mapBoxApiKey}
                                _center={{
                                    lat: propertyDetailsData.location.latitude, long: propertyDetailsData.location.longitude
                                }}
                                _zoom={12}
                                // cssStyle={{ width: 'auto', height: '350px', marginBottom: '0', borderRadius: 6 }}
                                // layer={isDark ? 'dark-v10' : 'light-v10'}
                                layer="streets-v11"
                            />
                            : <Paper mt={30} mb={30} className={classes.progress}><Loader color="#f39c12" variant="dots" size="sm"/></Paper>
                            // : <Progress color="#f39c12" radius="xl" size="xl" value={100} striped={false} animate={false}/>
                        }

                    </ClientOnly>
                </Stack>

            }
        />
    )

}
